import React from 'react';

import DaysPickerInput from '@shared/forms/components/DaysPickerField/DaysPickerInput';
import { FormField, WithFormField } from '@shared/forms/components/FormField';

type Props = {
  days: string[];
  error?: string;
  events?: { title: string; start: Date; end: Date; className?: string }[];
};

export default function DaysPickerField({
  name,
  label,
  required,
  days,
  events = [],
  error,
  ...props
}: WithFormField<Props>) {
  return (
    <FormField name={name} label={label} required={required} error={error}>
      {(field) => <DaysPickerInput days={days} events={events} {...field} {...props} />}
    </FormField>
  );
}
